<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="showModal"
        class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-100"
      >
        <div class="mx-20 md:mx-0 py-50 px-30 bg-primary max-w-350 w-full rounded-4">
          <div class="mx-auto relative" :class="isMockup ? 'w-165 h-120 -mt-50' : 'w-165 h-165'">
            <div class="progress">
              <svg v-if="!isMockup" class="progress-circle" width="160px" height="160px" xmlns="http://www.w3.org/2000/svg">
                <circle class="progress-circle-back" cx="80" cy="80" r="74" />
                <circle ref="progressRef" class="progress-circle-prog text-brand" cx="80" cy="80" r="74" />
              </svg>
              <svg class="h-50 absolute inner-icon" xmlns="http://www.w3.org/2000/svg" width="62" height="79" viewBox="0 0 62 79" fill="none">
                <path d="M13.472 39.7585C15.1064 29.1573 19.3922 -0.207436 23.4602 2.13214C28.5451 5.05661 20.8269 34.2751 23.4602 37.8088C26.0934 41.3425 30.7439 13.1945 35.9196 10.8793C41.0954 8.56414 33.3576 42.6829 31.9956 44.267C30.6335 45.8511 48.2409 18.359 49.0581 25.3046C49.6314 30.1769 44.2487 43.9576 41.0165 51.1662C40.6245 52.0406 40.4284 52.4778 40.5128 52.5699C40.5365 52.5958 40.566 52.6141 40.5997 52.6239C40.7196 52.6589 41.0236 52.2913 41.6316 51.5561C46.6178 45.5267 56.8851 33.4448 59.5171 35.7994C62.6498 38.602 44.2176 77.1807 26.5067 77.1807C6.99649 77.1807 4.11387 46.7333 2.5791 39.7585C-1.37755 21.7771 17.5876 39.8436 17.5876 51.115" stroke="#3F40F2" stroke-width="3.61446" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          <div class="text-app-color text-center mt-20">
            <p class="text-25 font-bold">{{ title }}</p>
            <p class="text-15 text-grey-20">{{ subTitle }}</p>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, computed, watch, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'WelcomeModal',

  props: {
    title: { type: String, default: 'You’re all set!' },
    subTitle: { type: String, default: 'We’re preparing your workspace.' },
    isMockup: { type: Boolean, default: false },
    initialValue: { type: Number, default: 5 }
  },

  setup (props) {
    const { state } = useStore()
    const showModal = computed(() => true)
    const progressRef = ref(null)

    const signupRequests = computed(() => state.auth.signupRequests)

    const koeff = computed(() => 100 / props.initialValue)

    watch(signupRequests, (value) => {
      if (value <= props.initialValue) {
        start()
      }
    })

    function start () {
      progressRef.value.style.strokeDasharray = (signupRequests.value * koeff.value * 4.65) + ' 999'
    }

    return {
      // refs
      progressRef,
      // computed
      showModal

      // function
    }
  }
})
</script>

<style scoped>

.progress {
  position: absolute;
  height: 165px;
  width: 165px;
  left: 50%;
  transform: translateX(-50%);
}

.progress-circle {
  transform: rotate(-90deg);
}

.progress-circle-back {
  fill: none;
  stroke: #eee;
  stroke-width: 5px;
}
.progress-circle-prog {
  fill: none;
  stroke: currentColor;
  stroke-width: 5px;
  stroke-dasharray: 0 999;
  stroke-dashoffset: 0px;
  transition: stroke-dasharray 0.7s linear 0s;
}

.inner-icon {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
